<template>
  <div class="neighborhood">
    <el-descriptions
      :column="6"
      direction="vertical"
      border
      labelClassName="c-descriptions-label"
      contentClassName="c-descriptions-content"
    >
      <template slot="title">
        <h3 @click="$router.go(-1)" class="c-pointer">
          <i class="el-icon-arrow-left"></i>
          {{ formData.nhName }}
        </h3>
      </template>
      <el-descriptions-item label="小区位置">
        <span class="c_size_14">
          <span v-if="formData.provinceStr">{{ formData.provinceStr }}/</span>
          <span v-if="formData.cityStr && formData.cityStr != '市辖区'">
            {{ formData.cityStr }}/
          </span>
          <span v-if="formData.districtStr">{{ formData.districtStr }}/</span>
          <span v-if="formData.subdistrictStr">{{ formData.subdistrictStr }}</span>
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="线索数">
        <span class="c_size_18 c-font-bold">{{ formData.lcount }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="工单数">
        <span class="c_size_18 c-font-bold">{{ formData.scount }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="合同数">
        <span class="c_size_18 c-font-bold">{{ formData.ccount }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="合同总金额">
        <span class="c_size_18 c-font-bold c_red">
          {{ formData.ccamount }}
          <span class="c_size_12">元</span>
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="客单价">
        <span class="c_size_18 c-font-bold c_red">
          {{ formData.perPrice }}
          <span class="c_size_12">元</span>
        </span>
      </el-descriptions-item>
    </el-descriptions>
    <div style="margin-top:50px" v-if="lead.data.length > 0">
      <h4>
        历史线索
      </h4>
      <el-table ref="leadTable" :data="lead.data">
        <el-table-column label="客户姓名" prop="name" width="100px" fixed>
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="osg.open('', '', '_blank', `/lead/${scope.row._id}`)"
              type="text"
            >
              {{ scope.row.name }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="客户手机" prop="phone" width="100px"></el-table-column>
        <el-table-column label="工单编号" prop="code" width="120px"></el-table-column>
        <el-table-column
          label="详细地址"
          prop="address"
          width="200px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="渗漏部位"
          prop="exts.leakagesite"
          :formatter="
            (row, column, cellValue) => {
              return osg.formatCascadeMultiple(
                'repairParts',
                osg.isJson(cellValue) ? JSON.parse(cellValue) : cellValue
              );
            }
          "
          width="200px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="信息来源"
          prop="exts.sourceType"
          :formatter="
            (row, column, cellValue) => {
              return osg.codelabel('sourceType', cellValue);
            }
          "
          width="100px"
        ></el-table-column>
        <el-table-column
          label="信息渠道"
          prop="channel"
          :formatter="
            (row, column, cellValue) => {
              return osg.formatCascade('channel', cellValue);
            }
          "
          width="230px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="线索状态"
          prop="leadStatus"
          :formatter="
            (row, column, cellValue) => {
              return osg.formatCascade('LEADSTATUS', cellValue);
            }
          "
          width="200px"
        ></el-table-column>
        <el-table-column label="创建时间" prop="createTime" min-width="140px"></el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="leadPageChange"
        :current-page="lead.page"
        :page-size="lead.rows"
        layout="total, prev, pager, next"
        :total="lead.total"
      ></el-pagination>
    </div>
    <div style="margin-top:50px" v-if="serviceAppointment.data.length > 0">
      <h4>
        历史工单
      </h4>
      <el-table ref="serviceAppointmentTable" :data="serviceAppointment.data">
        <el-table-column label="客户姓名" prop="name" width="100px" fixed>
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="
                osg.open('', '', '_blank', `/Flow/serviceAppointment/${scope.row._id}`)
              "
              type="text"
            >
              {{ scope.row.name }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="客户手机" prop="phone" width="100px"></el-table-column>
        <el-table-column label="工单编号" prop="orderNum" width="120px"></el-table-column>
        <el-table-column
          label="详细地址"
          prop="address"
          width="200px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="渗漏部位"
          prop="exts.leakagesite"
          :formatter="
            (row, column, cellValue) => {
              return osg.formatCascadeMultiple(
                'repairParts',
                osg.isJson(cellValue) ? JSON.parse(cellValue) : cellValue
              );
            }
          "
          width="200px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="信息来源"
          prop="exts.sourceType"
          :formatter="
            (row, column, cellValue) => {
              return osg.codelabel('sourceType', cellValue);
            }
          "
          width="110px"
        ></el-table-column>
        <el-table-column
          label="信息渠道"
          prop="channel"
          :formatter="
            (row, column, cellValue) => {
              return osg.formatCascade('channel', cellValue);
            }
          "
          width="230px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="服务商" prop="orgName" width="200px"></el-table-column>
        <el-table-column label="管家" prop="exts.supervisorName" width="100px"></el-table-column>
        <el-table-column
          label="工单阶段"
          prop="stage"
          :formatter="
            (row, column, cellValue) => {
              return osg.codelabel('STAGE', cellValue);
            }
          "
          width="100px"
        ></el-table-column>
        <el-table-column
          label="工单状态"
          prop="status"
          :formatter="
            (row, column, cellValue) => {
              return osg.codelabel('STATUS', cellValue);
            }
          "
          width="100px"
        ></el-table-column>
        <el-table-column label="创建时间" prop="createTime" min-width="140px"></el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="serviceAppointmentPageChange"
        :current-page="serviceAppointment.page"
        :page-size="serviceAppointment.rows"
        layout="total, prev, pager, next"
        :total="serviceAppointment.total"
      ></el-pagination>
    </div>
    <!-- 小区地图 -->
    <div class="map-view">
      <div id="container"></div>
      <div class="weather">
        <h4 class="c-m-t-5">天气预报</h4>
        <hr class="c-m-t-5 c-m-b-5" />
        <p id="forecast"></p>
      </div>
    </div>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      nhId: '',
      name: 'neighborhood',
      formData: { exts: {} },
      extFields: [],
      extField: {},
      options: {
        cascadeCode_repairParts: { codeId: 'repairParts' },
        codecfg_sourceType: { codeId: 'sourceType' },
        cascadeCode_channel: { codeId: 'channel' },
        cascadeCode_LEADSTATUS: { codeId: 'LEADSTATUS' },
        codecfg_STAGE: { codeId: 'STAGE' },
        codecfg_STATUS: { codeId: 'STATUS' }
      },
      lead: {
        page: 1,
        rows: 5,
        data: []
      },
      serviceAppointment: {
        page: 1,
        rows: 5,
        data: []
      },
      map: null
    };
  },
  mounted() {
    this.nhId = this.osg.param('id');
    this.osg.codeoption(() => {
      this.getData(() => {
        this.getLeads();
        this.getServiceAppointments();
        this.initAMap();
      });
    });
  },
  methods: {
    leadPageChange(currentPage) {
      this.lead.page = currentPage;
      this.getLeads();
    },
    serviceAppointmentPageChange(currentPage) {
      this.serviceAppointment.page = currentPage;
      this.getServiceAppointments();
    },
    getData(callback) {
      // 处理$match过滤
      this.osg.ajax(
        'stat/aggr/mb_stat_neighborhood.do',
        {
          aggr: JSON.stringify([
            {
              $match: { '_id.nhId': this.nhId }
            },
            {
              $group: {
                _id: '$_id.nhId',
                lcount: { $sum: '$lcount' },
                scount: { $sum: '$scount' },
                ccount: { $sum: '$ccount' },
                ccamount: { $sum: '$ccamount' }
              }
            },
            {
              $addFields: {
                ccamount: { $round: ['$ccamount', 0] }, // 四舍五入取整,
                perPrice: {
                  $cond: {
                    if: { $ne: ['$ccount', 0] },
                    then: { $round: [{ $divide: ['$ccamount', '$ccount'] }, 0] }, // 四舍五入取整,
                    else: 0
                  }
                }
              }
            },
            {
              $lookup: {
                from: 'neighborhood',
                let: { nhId: '$_id' },
                pipeline: [
                  {
                    $match: { $expr: { $eq: ['$_id', '$$nhId'] } }
                  }
                ],
                as: 'nhData'
              }
            },
            {
              $unwind: { path: '$nhData', preserveNullAndEmptyArrays: true }
            },
            {
              $project: {
                _id: '$_id',
                lcount: '$lcount',
                scount: '$scount',
                ccount: '$ccount',
                ccamount: '$ccamount',
                perPrice: '$perPrice',
                nhName: '$nhData.name',
                provinceStr: '$nhData.provinceStr',
                cityStr: '$nhData.cityStr',
                districtStr: '$nhData.districtStr',
                subdistrictStr: '$nhData.subdistrictStr',
                longitude: '$nhData.longitude',
                latitude: '$nhData.latitude'
              }
            }
          ])
        },
        res => {
          this.formData = res[0];
          if (callback) callback();
        }
      );
    },
    getLeads() {
      this.osg.ajax(
        'basic/lead/query.do',
        {
          page: this.lead.page,
          rows: this.lead.rows,
          'is:state|integer#and': 1,
          // 'is:community|string#or': this.formData.nhName,
          'is:exts.nhId|string#and': this.nhId,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.lead = res;
          this.$nextTick(() => {
            this.$refs.leadTable && this.$refs.leadTable.doLayout();
          });
        },
        {
          noload: true
        }
      );
    },
    getServiceAppointments() {
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        {
          page: this.serviceAppointment.page,
          rows: this.serviceAppointment.rows,
          'is:state|integer#and': 1,
          // 'is:community|string#or': this.formData.nhName,
          'is:exts.nhId|string#and': this.nhId,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.serviceAppointment = res;
          this.$nextTick(() => {
            this.$refs.serviceAppointmentTable && this.$refs.serviceAppointmentTable.doLayout();
          });
        },
        {
          noload: true
        }
      );
    },
    initAMap() {
      window._AMapSecurityConfig = {
        // securityJsCode: 'ac5c6d52c4941585f1ec57884dd34a4f'
        securityJsCode: '8b86d03ed2246c48dd5958880162c578'
      };
      AMapLoader.load({
        // key: '50c961dad0b7b63f7b5de0cc40ba7105', // 申请好的Web端开发者Key，首次调用 load 时必填
        key: '227547f3e341306debf77572580ca62a', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Scale', 'AMap.ToolBar', 'AMap.Weather'] //需要使用的的插件列表
      })
        .then(AMap => {
          this.map = new AMap.Map('container', {
            // 设置地图容器id
            viewMode: '2D', // 是否为3D地图模式
            zoom: 17, // 初始化地图级别
            center: [this.formData.longitude, this.formData.latitude] // 初始化地图中心点位置
          });

          //创建一个 Marker 实例：
          const marker = new AMap.Marker({
            position: new AMap.LngLat(this.formData.longitude, this.formData.latitude),
            anchor: 'bottom-center', //点标记锚点位置
            offset: [0, -20], //点标记显示位置偏移量，默认值为[0,0]
            content: `<div style="background-color:#5184f9;opacity:0.8;color:#fff;line-height:24px;padding:10px 14px;border-radius:2px;font-size:14px;box-shadow:0 0 4px rgba(0, 0, 0, .2);font-weight:900;white-space:nowrap;">${this.formData.nhName}<i style="position: absolute;width: 10px;height: 10px;bottom: -5px;left: 50%;background: #5184f9;margin-left: -5px;display: inline-block;-webkit-transform: rotate(45deg);transform: rotate(45deg);"></i><i style="width: 10px;height: 10px;border-radius: 50%;border: 3px solid #fff;bottom: -24px;left: 50%;margin-left: -7px;background: #5184f9;position: absolute;"></i></div>`
          });

          //将创建的点标记添加到已有的地图实例：
          this.map.add(marker);

          var toolbar = new AMap.ToolBar(); //创建工具条插件实例
          this.map.addControl(toolbar); //添加工具条插件到页面
          var scale = new AMap.Scale();
          this.map.addControl(scale);
          //创建天气查询实例
          var weather = new AMap.Weather();
          //执行实时天气信息查询
          //未来4天天气预报
          weather.getForecast(this.formData.districtStr, function(err, data) {
            if (err) {
              return;
            }
            var str = [];
            for (var i = 0, dayWeather; i < data.forecasts.length; i++) {
              dayWeather = data.forecasts[i];
              str.push(
                dayWeather.date +
                  ' <span class="weather">' +
                  dayWeather.dayWeather +
                  '</span> ' +
                  dayWeather.nightTemp +
                  '~' +
                  dayWeather.dayTemp +
                  '℃'
              );
            }
            document.getElementById('forecast').innerHTML = str.join('<br>');
          });
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.neighborhood {
  margin: 0;
  padding: 20px;
  overflow-y: auto;
  ::v-deep .c-descriptions-label {
    text-align: center !important;
  }
  ::v-deep .c-descriptions-content {
    text-align: center !important;
  }
  .map-view {
    position: relative;
    width: 100%;
    height: 500px;
    margin-top: 50px;
    #container {
      width: 100%;
      height: 500px;
    }
    .weather {
      position: absolute;
      background-color: #fff;
      top: 0;
      right: 0;
      padding: 0 10px 10px;
      opacity: 0.9;
      border-radius: 0 0 0 5px;
    }
  }
}
</style>
